"use strict";
exports.__esModule = true;
//# sourceMappingURL=entity.js.map